import { atom } from "recoil";

export const PhoneAtom = atom<string | null>({
  key: "PhoneAtom",
  default: null,
});
